export const SHIFT_REPORT_LIST = 'SHIFT_REPORT_LIST';
export const SHIFT_REPORT_SUCCESS = 'SHIFT_REPORT_SUCCESS';
export const SHIFT_REPORT_ERROR = 'SHIFT_REPORT_ERROR';
export const SHIFT_REPORT_DETAILS = 'SHIFT_REPORT_UPDATE_DETAILS';
export const SHIFT_LIST_DETAILS = 'SHIFT_LIST_DETAILS';
export const SHIFT_LIST_DETAILS_ERROR = 'SHIFT_LIST_DETAILS_ERROR';
export const SHIFT_LIST_DETAILS_SUCCESS = 'SHIFT_LIST_DETAILS_SUCCESS';

export const SHIFT_QUESTIONS = 'SHIFT_QUESTIONS';
export const SHIFT_QUESTIONS_ERROR = 'SHIFT_QUESTIONS_ERROR';
export const SHIFT_QUESTIONS_SUCCESS = 'SHIFT_QUESTIONS_SUCCESS';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';

